import { Store } from '../core/store';

/**
 * SweetAlert tarzı, sıfır-bağımlılık onay diyaloğu servisi.
 * Kullanım:  if (await confirmDialog({...})) { ... }
 * Görselleştirme components/smg-confirm.ts'te (app kabuğunda tek örnek).
 */
export type ConfirmTone = 'primary' | 'warning' | 'danger';

export interface ConfirmOptions {
  title: string;
  message: string;
  /** Tabler ikon sınıfı; verilmezse tona göre seçilir */
  icon?: string;
  tone?: ConfirmTone;
  okLabel?: string;
  cancelLabel?: string;
}

export interface ConfirmRequest extends Required<Omit<ConfirmOptions, 'icon'>> {
  icon: string;
  resolve: (answer: boolean) => void;
}

export const confirmStore = new Store<ConfirmRequest | null>(null);

const TONE_ICONS: Record<ConfirmTone, string> = {
  primary: 'ti ti-help-circle',
  warning: 'ti ti-alert-triangle',
  danger: 'ti ti-alert-triangle',
};

export function confirmDialog(options: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    const tone = options.tone ?? 'primary';
    confirmStore.set({
      title: options.title,
      message: options.message,
      tone,
      icon: options.icon ?? TONE_ICONS[tone],
      okLabel: options.okLabel ?? 'Evet',
      cancelLabel: options.cancelLabel ?? 'Vazgeç',
      resolve,
    });
  });
}

export function settleConfirm(answer: boolean): void {
  const current = confirmStore.get();
  if (!current) return;
  confirmStore.set(null);
  current.resolve(answer);
}
